import(/* webpackMode: "eager" */ "/app/app/(private)/error.tsx");
